import modelExtend from 'dva-model-extend';

import * as apis from 'services/item';
import { recalcSalePurchase } from 'services/data';
import { removeAccent } from 'utils/misc';
import { createAdvanceStaticModel } from './common';

const opt = {
  apis,
  namespace: 'item',
  singleAttr: 'item',
  listAttr: 'items',
  pathname: '/item',
  processDataItem: (item) => {
    item.search_slug = `${removeAccent(item.name)}`;
    if (item.alt_names) {
      item.alt_names.forEach((n) => {
        item.search_slug += `#${removeAccent(n)}`;
      });
    }
    item.search_slug += `#${removeAccent(item.note)}`;
  },
};
const model = createAdvanceStaticModel(opt);

export default modelExtend(model, {
  namespace: 'item',

  effects: {
    * merge({ payload, output }, { call }) {
      const data = yield call(apis.merge, { ids: payload });
      if (output) output.value = data;
      if (!data.success) throw data;
    },

    * recalcSalePurchase({ payload, output }, { call }) {
      const data = yield call(recalcSalePurchase, payload);
      output && (output.value = data);
      if (data.success) {
        // DO nothing
      } else {
        throw data;
      }
    },

  },
});



// WEBPACK FOOTER //
// ./src/models/item.js